var map = {
	"./click.svg": 4463,
	"./copy.svg": 8838,
	"./example.svg": 1649,
	"./eye.svg": 5628,
	"./form.svg": 3771,
	"./home.svg": 7123,
	"./password.svg": 9902,
	"./rank.svg": 2819,
	"./rankcollect.svg": 5359,
	"./sucai.svg": 1614,
	"./table.svg": 4383,
	"./tree.svg": 2701,
	"./user.svg": 8848
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2922;